<template>
  <div class="collision-check h-full overflow-hidden relative" v-loading="!modelLoadEnd">
    <categoryTitle class="mt-10px" title="碰撞检查记录" />
    <div class="flex items-center search-wrap my-5px">
      <!-- <el-input
        size="small"
        v-model="keyWord"
        placeholder="请输入关键词"
        clearable
        class="flex-0"
        @keypress.native.enter="searchList"
      >
        <i slot="append" class="el-icon-search cursor-pointer" @click="searchList"></i>
      </el-input> -->
      <el-input
        size="small"
        v-model="keyWord"
        placeholder="请输入关键词"
        clearable
        @keypress.native.enter="searchList"
        @clear="searchList"
      ></el-input>
      <el-button @click="searchList" size="small" type="primary" class="ml-10px">搜索</el-button>
      <el-button @click="newCheck" size="small" type="primary" class="ml-10px">新增检查</el-button>
      <el-button @click="exportThreeColumnsPDF" size="small" type="primary" class="ml-10px">导出</el-button>
      <!-- <div
        class="
          text-center
          button-bg-img
          text-white
          h-28px
          leading-28px
          px-15px
          ml-5px
          cursor-pointer
          whitespace-nowrap
        "
        @click="newCheck"
      >
        新增检查
      </div> -->
    </div>
    <el-table
      :data="tableData"
      :height="`calc(50% - 99px)`"
      class="collision-table"
      highlight-current-row
      row-key="id"
      stripe
    >
      <el-table-column prop="no" label="碰撞编号" show-overflow-tooltip></el-table-column>
      <el-table-column prop="checkTime" label="检查日期" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" width="130">
        <template slot-scope="{ row }">
          <span @click="collisionEdit(row)" size="small" class="text-[#44F1FF] cursor-pointer"
            >编辑</span
          >
          <span
            @click="collisionPreview(row)"
            size="small"
            class=" ml-10px text-[#44F1FF] cursor-pointer"
            >查看</span
          >
          <span
            @click="collisionDelete(row)"
            size="small"
            class=" ml-10px text-[#44F1FF] cursor-pointer"
            >删除</span
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      small
      background
      @current-change="getTableData"
      :current-page.sync="page.pageNo"
      :page-size="page.pageSize"
      layout="total, prev, pager, next"
      :total="page.total"
      :pager-count="5"
      class="flex justify-end mt-10px"
    ></el-pagination>
    <categoryTitle class="my-10px" title="碰撞检查详情" />
    <div class="h-[calc(50%-38px)] text-16px overflow-auto">
      <div class="flex py-6px" v-for="(item, index) in detailCol" :key="index">
        <div class="w-100px flex-shrink-0 text-[#b9b9b9] text-right">{{ item.name }}：</div>
        <div
          v-if="item.code === 'pos'"
          class="flex-grow text-[#fff] truncate"
          :title="`X:${detailData.xPosition} Y:${detailData.yPosition} Z:${detailData.zPosition}`"
        >
          {{
            detailData.xPosition
              ? `X:${detailData.xPosition} Y:${detailData.yPosition} Z:${detailData.zPosition}`
              : ''
          }}
        </div>
        <div
          v-else
          class="flex-grow text-[#fff]"
          :title="item.ellipsis ? detailData[item.code] : false"
          :class="[
            item.ellipsis ? 'truncate' : 'leading-20px',
            {
              '!text-[#44f1ff] cursor-pointer':
                item.code === 'mainName' || item.code === 'guestName',
            },
          ]"
          @click="detailClick(item.code, detailData[item.code])"
        >
          {{ detailData[item.code] }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import categoryTitle from '@/components/cockpit/CategoryTitle'
import { CollisionCheckApi } from '@wiz-api/collision-detection'
import html2canvas from 'html2canvas'
import JSPDF from 'jspdf'
import { multipleLocations } from './js/publicModelMays'
import EventBus from './js/eventBus'

const collisionCheckApi = new CollisionCheckApi()

export default {
  name: 'CollisionCheck',
  components: { categoryTitle },
  props: {
    player: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    modelNode: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    // 模型加载完成
    modelLoadEnd: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      keyWord: '',
      materialObj: {
        previewSubNodePtr: null,
        previewObNodePtr: null,
        subMaterial: null,
        obMaterial: null,
      },
      detailData: {
        no: '',
        checkTime: '',
        mainCode: '',
        mainName: '',
        guestCode: '',
        guestName: '',
        xPosition: '',
        yPosition: '',
        zPosition: '',
        description: '',
        collisionType: 0,
      },
      detailCol: [
        {
          code: 'no',
          name: '碰撞编号',
          ellipsis: true,
        },
        {
          code: 'checkTime',
          name: '创建日期',
          ellipsis: true,
        },
        // {
        //   code: 'mainCode',
        //   name: '主体编码',
        //   ellipsis: true,
        // },
        {
          code: 'mainName',
          name: '主体名称',
          ellipsis: true,
        },
        // {
        //   code: 'guestCode',
        //   name: '客体编码',
        //   ellipsis: true,
        // },
        {
          code: 'guestName',
          name: '客体名称',
          ellipsis: true,
        },
        {
          code: 'pos',
          name: '碰撞点坐标',
          ellipsis: true,
        },
        {
          code: 'description',
          name: '碰撞描述',
          ellipsis: false,
        },
        {
          code: 'collisionConfig',
          name: '碰撞类型',
          ellipsis: false,
        },
      ],
      tableData: [],
    }
  },
  watch: {

  },
  methods: {
    async exportThreeColumnsPDF() {
      // 准备导出数据
      const exportData = this.tableData.map((row) => {
        return {
          主体名称: row.mainName,
          客体名称: row.guestName,
          坐标点: `${Number(row.xPosition).toFixed(2)},${Number(row.yPosition).toFixed(2)},${Number(row.zPosition).toFixed(2)}`
        }
      })

      // 创建HTML内容
      const htmlContent = this.createTableHTML(exportData)

      // 创建临时容器
      const container = document.createElement('div')
      container.style.cssText = `
        position: fixed;
        left: -9999px;
        top: 0;
        width: 800px;
        background: white;
        padding: 20px;
      `
      container.innerHTML = htmlContent
      document.body.appendChild(container)

      try {
        // 转换为PDF
        const canvas = await html2canvas(container, { scale: 2, backgroundColor: '#fff' })
        const pdf = new JSPDF('p', 'mm', 'a4')
        const imgWidth = 190
        const imgHeight = (canvas.height * imgWidth) / canvas.width

        pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 10, 10, imgWidth, imgHeight)
        pdf.save('碰撞检查记录.pdf')

        this.$message.success('导出成功')
      } catch (error) {
        console.error('导出失败:', error)
        this.$message.error('导出失败')
      } finally {
        document.body.removeChild(container)
      }
    },
    createTableHTML(data) {
      return `
        <div style="font-family: 'Microsoft YaHei';">
          <h2 style="text-align: center;margin-bottom: 20px;">碰撞检查记录</h2>
          <table border="1" cellspacing="0" cellpadding="10" style="width: 100%; border-collapse: collapse;">
            <thead>
              <tr style="background-color: #f0f0f0;">
                <th style="border: 1px solid #ccc;">主体名称</th>
                <th style="border: 1px solid #ccc;">客体名称</th>
                <th style="border: 1px solid #ccc;">坐标点 (X,Y,Z)</th>
              </tr>
            </thead>
            <tbody>
              ${data.map((item) => {
    return `
                <tr>
                  <td style="border: 1px solid #ccc; padding: 8px;">${item.主体名称}</td>
                  <td style="border: 1px solid #ccc; padding: 8px;">${item.客体名称}</td>
                  <td style="border: 1px solid #ccc; padding: 8px;">${item.坐标点}</td>
                </tr>
              `
  }).join('')}
            </tbody>
          </table>
          <div style="margin-top: 20px; color: #666; font-size: 12px;">
            导出时间: ${new Date().toLocaleString()} | 记录数: ${data.length}
          </div>
        </div>
      `
    },
    // 新增检查
    newCheck() {
      this.$emit('transferEvent', {
        toCom: { code: 'NewCollisionCheck', origin: 'CollisionCheck', name: '新建碰撞检查' },
        type: 'mainComponent',
        props: {
          materialObj: this.materialObj,
        },
      })
    },
    async detailClick(type, name) {
      if ((type === 'mainName' || type === 'guestName') && this.player) {
        const rootNode = await this.player.Native.Node.getRoot()
        if (rootNode) {
          const curNode = await this.player.Native.Node.findNodeByName(rootNode, name)
          if (curNode) {
            const NodeInfo = await this.player.Native.Node.getProperty(curNode, ['name', 'code', 'localTrans', 'localRot', 'localScale', 'globalTrans', 'globalRot', 'parent', 'children', 'visible', 'material', 'aabb'])
            if (!NodeInfo || !NodeInfo.node) {
              this.$message.warning('当前加载无node节点')
            }
            multipleLocations(this.player, NodeInfo)
          } else {
            this.$message.warning('未找到当前节点')
          }
        }
      }
    },
    // 获取表数据
    async getTableData() {
      const [err, res] = await collisionCheckApi.getCollisionCheckList({
        body: {
          maxResultCount: this.page.pageSize,
          skipCount: (this.page.pageNo - 1) * this.page.pageSize,
          sorting: '',
          keywords: this.keyWord,
          tenantId:
            localStorage.getItem('CurrentTenantId') ||
            localStorage.getItem('TenantId') ||
            JSON.parse(localStorage.getItem('CurrentUser'))?.TenantId,
        },
      })
      if (!err && res && res.items) {
        this.tableData = res.items
        this.page.total = res.totalCount
      }
      this.detailData = this.$options.data().detailData
    },
    // 重置碰撞预览颜色
    async resetNodeMaterial() {
      if (this.materialObj.previewSubNodePtr && this.materialObj.previewObNodePtr) {
        await this.player.Native.Node.setProperty([
          {
            node: this.materialObj.previewSubNodePtr,
            props: { colorIndex: 0 }
          },

          {
            node: this.materialObj.previewObNodePtr,
            props: { colorIndex: 0 }
          }
        ])
      }
      this.materialObj = this.$options.data().materialObj
      EventBus.$emit('listMaterialNodeChange', false)
    },
    materialNodeChange(data) {
      if (!data) {
        this.materialObj = this.$options.data().materialObj
      } else {
        this.materialObj = Object.assign(this.materialObj, data)
      }
    },
    // 碰撞预览
    async collisionPreview(row) {
      await this.resetNodeMaterial()
      row.collisionConfig = row.collisionType === 0 ? '静态碰撞' : '动态碰撞'
      this.detailData = Object.assign(this.detailData, row)
      const rootNode = await this.player.Native.Node.getRoot()
      if (rootNode) {
        this.player.Native.Camera.moveToPos(
          [parseFloat(row.xPosition), parseFloat(row.yPosition), parseFloat(row.zPosition)],
          rootNode,
          2,
          1
        )
        this.materialObj.previewSubNodePtr = await this.player.Native.Node.findNodeByName(
          rootNode,
          row.mainName
        )
        this.materialObj.previewObNodePtr = await this.player.Native.Node.findNodeByName(
          rootNode,
          row.guestName
        )
        if (this.materialObj.previewSubNodePtr && this.materialObj.previewObNodePtr) {
          await this.player.Native.Node.setProperty([
            {
              node: this.materialObj.previewSubNodePtr,
              props: { colorIndex: 32 }
            },
            {
              node: this.materialObj.previewObNodePtr,
              props: { colorIndex: 45 }
            },
          ])
          EventBus.$emit('listMaterialNodeChange', this.materialObj)
        } else {
          this.$message.warning('未查找到模型节点')
        }
      }
    },
    // 碰撞编辑
    async collisionEdit(row) {
      const [err, res] = await collisionCheckApi.getCollisionActionList({ checkId: row.id })
      let actions = []
      if (!err && res) {
        actions = res
      }
      const filterEvent = new CustomEvent('openCollisionEdit', {
        detail: {
          collisionInfo: { ...row },
          actions: actions || [],
        },
      })
      window.dispatchEvent(filterEvent)
    },
    // 碰撞删除
    async collisionDelete(row) {
      const ids = [row.id]
      const [err, res] = await collisionCheckApi.deleteCheck({ body: ids })
      if (res) {
        this.$message.success('删除成功')
        this.searchList()
      }
    },
    searchList() {
      this.page.pageNo = 1
      this.getTableData()
    },
    async closeSelect() {
      const selectNodes = await this.player.Native.Node.getSeletedNodes()
      if (selectNodes.length > 0) {
        await this.player.Native.Node.unSelectNodes(selectNodes)
      }
    }
  },
  beforeDestroy() {
    this.resetNodeMaterial()
    this.closeSelect()
    EventBus.$off('CollisionEditSuccess', this.searchList)
    EventBus.$off('materialNodeChange', this.materialNodeChange)
  },
  created() {
    EventBus.$on('CollisionEditSuccess', this.searchList)
    EventBus.$on('materialNodeChange', this.materialNodeChange)
    this.getTableData()
    // this.$emit('collisionReload')
  },
}
</script>
<style lang="scss" scoped>
.collision-check {
  .search-wrap {
    ::v-deep .el-input__inner {
      background: url('../../../assets/images/cockpitNew/input-bg.png') no-repeat !important;
      background-size: 100% 100% !important;
      border: none !important;
      border-radius: unset !important;
    }

    ::v-deep .el-button {
      height: 36px !important;
      background-color: rgb(67 153 174 / 0.35) !important;
      border: 1px solid #629eaa !important;
      border-radius: 2px !important;
      background-image: none !important;
    }
  }

  .collision-table {
    ::v-deep .el-checkbox__inner {
      background-color: transparent !important;
      border-color: #adadad !important;

      &::after {
        top: 0 !important;
        left: 4px !important;
      }
    }

    ::v-deep .el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: transparent !important;
      border-color: #fff !important;
    }

    ::v-deep .el-table__body tr.el-table__row--striped td.el-table__cell {
      background-color: transparent !important;
    }

    ::v-deep .el-table__row.el-table__row--striped {
      background: linear-gradient(0deg, #17c5dc5e, #1de3fd1a);
    }

    ::v-deep .el-table__body .current-row {
      background: linear-gradient(0deg, #986c36, #986c3666);
    }
  }

  .button-bg-img {
    background: url('../../../assets/images/button_blue.png');
    background-size: 100% 100%;
  }

  ::v-deep {
    // .el-input--small .el-input__inner {
    //   height: 28px !important;
    //   line-height: 28px !important;
    // }
    // .el-input__suffix i {
    //   height: 28px !important;
    //   line-height: 28px !important;
    // }
    .el-pagination.is-background.el-pagination--small .btn-next,
    .el-pagination.is-background.el-pagination--small .btn-prev,
    .el-pagination.is-background.el-pagination--small .el-pager li {
      margin: 0 4px !important;
      min-width: 26px !important;
    }

    .el-input-group__append,
    .el-input-group__prepend {
      border-color: var(--cockpitInputBorderColor) !important;
    }
  }
}
</style>
